import {
  ILayout,
  ILayout_Options,
  ILayout_Cell_Type_Empty,
  ILayout_Cell_Type_Text,
  ILayout_Cell_Type_Image,
  ILayout_Cell_Type_Video,
  ILayout_Cell_Type_File,
  ILayout_Cell_Type_Table,
  ILayout_Cell_Type_HTML,
  ILayout_Cell_Type_Booking_Details,

  ILayout_Node_Type_Layout,
  ILayout_Node_Type_Row,
  ILayout_Node_Type_Row_Inner,
  ILayout_Node_Type_Cell,
  ILayout_Cell_Props_Image_SizeField,
  ILayout_Cell_Props_Image_SizeUnit,

  ILayout_HorizontalAlign_Left,
  ILayout_HorizontalAlign_Center,
  ILayout_HorizontalAlign_Right,
  ILayout_HorizontalAlign,

  ILayout_VerticalAlign_Top,
  ILayout_VerticalAlign_Middle,
  ILayout_VerticalAlign_Bottom,
  ILayout_VerticalAlign,

  ILayout_RenderMode_Table,
  ILayout_RenderMode_Flex,

  ILayout_Option_Type,
} from '../types/layout'

import {
  ENABLED_MAGIC_TAGS_ASTONISH_TEXT_EDITOR,
  ENABLED_MAGIC_TAGS_ASTONISH_LINK_EDITOR,
  ENABLED_MAGIC_TAGS_KNOWLEDGEBASE_TEXT_EDITOR,
  ENABLED_MAGIC_TAGS_KNOWLEDGEBASE_LINK_EDITOR,
  ENABLED_MAGIC_TAGS_FORM_TEXT_EDITOR,
  ENABLED_MAGIC_TAGS_FORM_LINK_EDITOR,
} from './magictag'

import {
  TEXT_EDITOR_LINK_TYPE_TEXT,
  TEXT_EDITOR_LINK_TYPE_FILE,
  TEXT_EDITOR_LINK_TYPE_KNOWLEDGEBASE,
  TEXT_EDITOR_LINK_TYPE_ASTONISH_OPEN_BROWSER,
  TEXT_EDITOR_LINK_TYPE_ASTONISH_UNSUBSCRIBE,
} from './texteditor'

export const LAYOUT_MEDIA_QUERY_WIDTH = '800px'

export const LAYOUT_RENDER_MODE_TABLE: ILayout_RenderMode_Table = 'table'
export const LAYOUT_RENDER_MODE_FLEX: ILayout_RenderMode_Flex = 'flex'

export const LAYOUT_HORIZONTAL_ALIGN_LEFT: ILayout_HorizontalAlign_Left = 'left'
export const LAYOUT_HORIZONTAL_ALIGN_CENTER: ILayout_HorizontalAlign_Center = 'center'
export const LAYOUT_HORIZONTAL_ALIGN_RIGHT: ILayout_HorizontalAlign_Right = 'right'
export const LAYOUT_HORIZONTAL_ALIGN_DEFAULT: ILayout_HorizontalAlign = LAYOUT_HORIZONTAL_ALIGN_LEFT

export const LAYOUT_VERTICAL_ALIGN_TOP: ILayout_VerticalAlign_Top = 'top'
export const LAYOUT_VERTICAL_ALIGN_MIDDLE: ILayout_VerticalAlign_Middle = 'middle'
export const LAYOUT_VERTICAL_ALIGN_BOTTOM: ILayout_VerticalAlign_Bottom = 'bottom'
export const LAYOUT_VERTICAL_ALIGN_DEFAULT: ILayout_VerticalAlign = LAYOUT_VERTICAL_ALIGN_TOP

export const LAYOUT_CELL_TYPE_EMPTY: ILayout_Cell_Type_Empty = 'empty'
export const LAYOUT_CELL_TYPE_TEXT: ILayout_Cell_Type_Text = 'text'
export const LAYOUT_CELL_TYPE_IMAGE: ILayout_Cell_Type_Image = 'image'
export const LAYOUT_CELL_TYPE_VIDEO: ILayout_Cell_Type_Video = 'video'
export const LAYOUT_CELL_TYPE_FILE: ILayout_Cell_Type_File = 'file'
export const LAYOUT_CELL_TYPE_TABLE: ILayout_Cell_Type_Table = 'table'
export const LAYOUT_CELL_TYPE_HTML: ILayout_Cell_Type_HTML = 'html'
export const LAYOUT_CELL_TYPE_BOOKING_DETAILS: ILayout_Cell_Type_Booking_Details = 'booking_details'

export const LAYOUT_NODE_TYPE_LAYOUT: ILayout_Node_Type_Layout = 'layout'
export const LAYOUT_NODE_TYPE_ROW: ILayout_Node_Type_Row = 'row'
export const LAYOUT_NODE_TYPE_ROW_INNER: ILayout_Node_Type_Row_Inner = 'rowinner'
export const LAYOUT_NODE_TYPE_CELL: ILayout_Node_Type_Cell = 'cell'

export const LAYOUT_DEFAULT_DATA: ILayout = {
  rows: [{
    cells: [{
      type: 'empty',
      data: {},
    }]
  }]
}

export const LAYOUT_IMAGE_SIZE_FIELD_DEFAULT: ILayout_Cell_Props_Image_SizeField = 'width'
export const LAYOUT_IMAGE_SIZE_FIELDS: ILayout_Cell_Props_Image_SizeField[] = [
  'width',
  'height',
]

export const LAYOUT_IMAGE_SIZE_UNIT_DEFAULT: ILayout_Cell_Props_Image_SizeUnit = '%'
export const LAYOUT_IMAGE_SIZE_UNITS: ILayout_Cell_Props_Image_SizeUnit[] = [
  'px',
  '%',
]

export const LAYOUT_IMAGE_SIZE_AMOUNT_DEFAULT = 100

export const LAYOUT_OPTIONS_WIDTH_DEFAULT = 800
export const LAYOUT_OPTIONS_WIDTH_ASTONISH = 600

export const LAYOUT_OPTIONS_ASTONISH: ILayout_Options = {
  name: 'astonish',
  width: LAYOUT_OPTIONS_WIDTH_ASTONISH,
  publicFiles: true,
  textMagicTags: ENABLED_MAGIC_TAGS_ASTONISH_TEXT_EDITOR,
  linkMagicTags: ENABLED_MAGIC_TAGS_ASTONISH_LINK_EDITOR,
  linkTypes: [
    TEXT_EDITOR_LINK_TYPE_TEXT,
    TEXT_EDITOR_LINK_TYPE_ASTONISH_OPEN_BROWSER,
    TEXT_EDITOR_LINK_TYPE_ASTONISH_UNSUBSCRIBE,
    TEXT_EDITOR_LINK_TYPE_FILE,
  ],
  hideSaveButton: true,
  hidePreviewButton: true,
  widgets: [
    LAYOUT_CELL_TYPE_TEXT,
    LAYOUT_CELL_TYPE_IMAGE,
    LAYOUT_CELL_TYPE_HTML,
  ],
}

export const LAYOUT_OPTIONS_ASTONISH_TEMPLATE: ILayout_Options = Object.assign({}, LAYOUT_OPTIONS_ASTONISH, {
  hideSaveButton: true,
})

export const LAYOUT_OPTIONS_ASTONISH_LOCKED: ILayout_Options = Object.assign({}, LAYOUT_OPTIONS_ASTONISH, {
  disableAdd: true,
  disableDelete: true,
  disableMove: true,
  lockedCells: true,
})

export const LAYOUT_OPTIONS_WIDTH_KNOWLEDGEBASE = 800

export const LAYOUT_OPTIONS_KNOWLEDGEBASE: ILayout_Options = {
  name: 'knowledgebase',
  renderMode: LAYOUT_RENDER_MODE_FLEX,
  width: LAYOUT_OPTIONS_WIDTH_KNOWLEDGEBASE,
  sharedFiles: true,
  textMagicTags: ENABLED_MAGIC_TAGS_KNOWLEDGEBASE_TEXT_EDITOR,
  linkMagicTags: ENABLED_MAGIC_TAGS_KNOWLEDGEBASE_LINK_EDITOR,
  linkTypes: [
    TEXT_EDITOR_LINK_TYPE_TEXT,
    TEXT_EDITOR_LINK_TYPE_FILE,
    TEXT_EDITOR_LINK_TYPE_KNOWLEDGEBASE,
  ],
  hideSaveButton: true,
  hidePreviewButton: true,
  widgets: [
    LAYOUT_CELL_TYPE_TEXT,
    LAYOUT_CELL_TYPE_IMAGE,
    LAYOUT_CELL_TYPE_VIDEO,
    LAYOUT_CELL_TYPE_FILE,
    LAYOUT_CELL_TYPE_TABLE,
    LAYOUT_CELL_TYPE_HTML,
  ],
}

export const LAYOUT_OPTIONS_WIDTH_FORM = 800

export const LAYOUT_OPTIONS_FORM: ILayout_Options = {
  name: 'form',
  fullWidth: true,
  renderMode: LAYOUT_RENDER_MODE_FLEX,
  publicFiles: true,
  textMagicTags: ENABLED_MAGIC_TAGS_FORM_TEXT_EDITOR,
  linkMagicTags: ENABLED_MAGIC_TAGS_FORM_LINK_EDITOR,
  linkTypes: [
    TEXT_EDITOR_LINK_TYPE_TEXT,
    TEXT_EDITOR_LINK_TYPE_FILE,
  ],
  hideSaveButton: false,
  hidePreviewButton: true,
  disabledLockedCells: true,
  saveButtonTitle: 'Apply',
  widgets: [
    LAYOUT_CELL_TYPE_TEXT,
    LAYOUT_CELL_TYPE_IMAGE,
    LAYOUT_CELL_TYPE_VIDEO,
    LAYOUT_CELL_TYPE_FILE,
    LAYOUT_CELL_TYPE_TABLE,
    LAYOUT_CELL_TYPE_HTML,
  ],
}

export const LAYOUT_OPTIONS_DEFAULT = LAYOUT_OPTIONS_FORM

export const LAYOUT_OPTIONS_MAP: Record<ILayout_Option_Type, ILayout_Options> = {
  astonish: LAYOUT_OPTIONS_ASTONISH,
  astonish_locked: LAYOUT_OPTIONS_ASTONISH_LOCKED,
  astonish_template: LAYOUT_OPTIONS_ASTONISH_TEMPLATE,
  knowledgebase: LAYOUT_OPTIONS_KNOWLEDGEBASE,
  form: LAYOUT_OPTIONS_FORM,
  default: LAYOUT_OPTIONS_DEFAULT,
}